import { createSlice } from '@reduxjs/toolkit';

import {
  WORK_SHOWS,
  WORK_SHOW_STORAGE_KEY,
  getWorkShowLocality,
  getWorkShowIanaTimezone
} from '../../utils/constant/global';

const getInitialOfficeId = () => {
  const stored = localStorage.getItem(WORK_SHOW_STORAGE_KEY);
  if (stored && WORK_SHOWS.some((ws) => ws.id === stored)) {
    return stored;
  }
  return WORK_SHOWS[0].id;
};

const initialOfficeId = getInitialOfficeId();

const initialState = {
  selectedOfficeId: initialOfficeId,
  locality: getWorkShowLocality(initialOfficeId),
  timezone: getWorkShowIanaTimezone(initialOfficeId)
};

export const officeSlice = createSlice({
  name: 'office',
  initialState,
  reducers: {
    setSelectedOffice: (state, action) => {
      const officeId = action.payload;
      state.selectedOfficeId = officeId;
      state.locality = getWorkShowLocality(officeId);
      state.timezone = getWorkShowIanaTimezone(officeId);
    }
  }
});

export const { setSelectedOffice } = officeSlice.actions;

export const selectSelectedOfficeId = (state) => state.office.selectedOfficeId;
export const selectOfficeLocality = (state) =>
  state.office?.locality || state.office?.nationality || [];
export const selectOfficeTimezone = (state) =>
  state.office?.timezone || getWorkShowIanaTimezone(state.office?.selectedOfficeId);

/** @deprecated Use selectOfficeLocality */
export const selectOfficeNationality = selectOfficeLocality;

export const officeReducer = officeSlice.reducer;
